import { inject } from "aurelia";
import { I18N, Signals } from "@aurelia/i18n";
import { formatDate } from "../../common/dates";

@inject(I18N)
export class DateValueConverter {
  signals = [Signals.I18N_SIGNAL];

  constructor(i18n) {
    this.i18n = i18n;
  }

  toView(value, format) {
    if (!value) return "-";
    if (!format) format = "YYYY-MM-DD HH:mm";
    return formatDate(value, format, this.i18n.getLocale());
  }
}
